// Options for the observer (which mutations to observe)
const config = { attributes: true };

function setToastPlacement(){
  const pageElement = document.querySelector(`wa-page`)
  const toastElement = document.querySelector(`wa-toast`)
  if(pageElement.view == `mobile`) {
    toastElement.placement = `top-end`
  } else {
    toastElement.placement = `top-center`
  }
}

function changeWaToastPlacement(mutationList, observer) {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes") {
      if(mutation.attributeName == `view`) {

        setToastPlacement()
      }
    }
  }
};

class SelfCheckinToast extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(!this.isConnected){ return }

    if(!this.mutationObserver) {
      this.mutationObserver = new MutationObserver(changeWaToastPlacement);
      this.mutationObserver.observe(this.pageElement, config);
    }

  }

  get pageElement() {
    return this.querySelector(`:scope > wa-page`)
  }
}

if (!window.customElements.get(`self-checkin-toast`)) {
  window.customElements.define(`self-checkin-toast`, SelfCheckinToast);
}
